import React from 'react';
import { Routes, Route } from 'react-router-dom';
import OriginList from './OriginList';
import OriginForm from './OriginForm';

const Origins = () => {
  return (
    <Routes>
      <Route index element={<OriginList />} />
      <Route path="new" element={<OriginForm />} />
      <Route path=":id/edit" element={<OriginForm />} />
    </Routes>
  );
};

export default Origins;
